import layout from 'styles/LandingLayout.module.scss';
import PropTypes from 'prop-types';

/**
 * # LandingSection
 * Wrapper of each Landing Section, adds the gradient background and optionally adds the section-container mixins, to control the content with on each screen break-point
 * @param { string } className - Add class to the Parent div.
 * @param { Node } children - React Node
 * @param { boolean } disableContentWidth - Boolean that indicates if the wrapper will control the content width with the section-container sass mixins
 * @returns
 */
const LandingSection = ({
    className,
    children,
    disableContentWidth,
    disableGradient,
    disableTopPadding = false,
    disableBottomPadding = false,
    enableColor = false
}) => {
    if (disableContentWidth) {
        return (
            <div
                className={`
                    ${layout.landing__section_background}
                    ${!disableGradient && layout.gradient}
                    ${enableColor && layout.landing__section_background_color}
                    ${className}
                `}
            >
                {children}
            </div>
        );
    }

    return (
        <div
            className={`
                ${layout.landing__section_background}
                ${!disableGradient && layout.gradient}
                ${layout.landing_section}
                ${!disableTopPadding && layout.landing_section_top_padding}
                ${!disableBottomPadding && layout.landing_section_bottom_padding}
                ${enableColor && layout.landing__section_background_color}
                ${className}
            `}
        >
            <div className={layout.landing__section_content}>{children}</div>
        </div>
    );
};

LandingSection.propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf([PropTypes.node])
    ]).isRequired,
    disableContentWidth: PropTypes.bool,
    disableGradient: PropTypes.bool,
    disableTopPadding: PropTypes.bool,
    disableBottomPadding: PropTypes.bool,
    enableColor: PropTypes.bool
};

export default LandingSection;
